export interface PDFConfig {
    baseFontSize: number;
    includePageNumbers: boolean;
    useWebForPDF?: boolean;
    includeAbsentModels?: boolean;
}

export const DEFAULT_PDF_CONFIG: PDFConfig = {
    baseFontSize: 10,
    includePageNumbers: true,
    useWebForPDF: undefined
};
